import Image from "components/shared/Image";

const mainClass = "syndicated-footer__means-of-payment";
const MeansOfPayment = ({ title, description, modules = [] }) => {
	return (
		<div className={mainClass}>
			{title && (
				<div
					className={`${mainClass}__title`}
					dangerouslySetInnerHTML={{ __html: title }}
				></div>
			)}
			<div className={`${mainClass}__items`}>
				{modules?.map(({ image, componentName }) => {
					return (
						<Image
							key={componentName}
							name="means-of-payment"
							image={{
								url: image?.url,
								title: image?.alt,
							}}
						/>
					);
				})}
			</div>

			{description && (
				<p className={`${mainClass}__description`}>{description}</p>
			)}
		</div>
	);
};

export default MeansOfPayment;
